import { Component, OnInit, OnDestroy, ViewChild, ComponentRef } from '@angular/core';
import { FacilityService } from 'src/app/core/services/facility.service';
import { StatsService } from '../services/stats.service';
import { Subscription } from 'rxjs';
import { CommonUtil } from 'src/app/core/Utils/common-util';
@Component({
  selector: 'app-stats',
  templateUrl: './stats.component.html',
  styleUrls: ['./stats.component.scss']
})
export class StatsComponent {
  productMixData: any;
  dateFrom = new Date();
  dateTo = new Date();
  equipmentColorMap: any[] = [{id: 1, colour: "#4196b4"},{id: 2, colour: "#f5bc46"},{id: 3, colour: "#8bc53e"},{id: 4, colour: "#a8b6b3"},{id: 12, colour: "#c9e363"},{id: 15, colour: "#f6b3ab"},{id: 16, colour: "#ff6c41"},{id: 18, colour: "#1cb19d"},{id: 19, colour: "#8bfffb"},{id: 20, colour: "#92B0DB"},{id: 101, colour: "#7ad0f8"},{id: 28, colour: "#9C94A8"},{id: 17, colour: "#EB5F60"}, {id:10001, colour: "#CC99CC"}];
  private sub = new Subscription();
  constructor(private _statsService: StatsService,
    private _facilityService: FacilityService,
    private commonUtil: CommonUtil,
  ) {}

  async ngOnInit(){
    //Reset Default Date when user landed on the stats module.
    this.dateFrom.setDate(this.dateFrom.getDate() - 90);
    this.dateTo.setDate(this.dateTo.getDate() - 1);
    this._statsService.updateStatsDateFilter({dateFrom:this.dateFrom,dateTo:this.dateTo});
 
    const facilitySub = this._facilityService.selectedFacilitySource.subscribe(async (res) => {
      if(res.summary.facilityRights.stats === 'false' || res.summary.userRights.stats === 'H' ){
        this.commonUtil.redirectToAvailablePage();
      }else{
        this.productMixData = await this.getProductMix(this._facilityService.selectedFacilityId());
        this.dateFrom = new Date(new Date().setDate(new Date().getDate() - 90));
        this.dateTo = new Date(new Date().setDate(new Date().getDate() - 1));
        this._statsService.updateStatsDateFilter({dateFrom:this.dateFrom,dateTo:this.dateTo});
      }
    });
    this.productMixData = await this.getProductMix(this._facilityService.selectedFacilityId());
    this.sub.add(facilitySub);

    //Apply Scroll Position.
    if(localStorage.getItem('quickFilterStatus')){
      this.commonUtil.scrollToView('stats_detailed_view');
    }else{
      this.commonUtil.scrollTop();
    }
  }



  getProductMix(facilityId: string) {
    return this._statsService.getDonutData(facilityId).toPromise();
  }

  ngOnDestroy(){
    this.sub.unsubscribe();
  }

}
